import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppStorage } from 'app/services';

@Component({
    selector: 'app-restriction-notification',
    templateUrl: './restriction-notification.component.html',
    styleUrls: ['./restriction-notification.component.scss'],
    standalone: false
})
export class RestrictionNotificationComponent implements OnInit {

  attemptedAction: string;

  freeHarvests: number;
  freeTemplates: number;
  freeUsers: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
    , public appStorage: AppStorage
    , private dialogRef: MatDialogRef<RestrictionNotificationComponent>
    , private router: Router
  ) { }

  ngOnInit(): void {
    this.attemptedAction = this.data
    this.dialogRef.addPanelClass('user-restriction-redesign');
  }

  get isUserLimit(): boolean { return this.attemptedAction === 'userAdd'; }

  get resourceName(): string {
    if (this.attemptedAction === 'harvestAdd') { return 'harvests'; }
    if (this.attemptedAction === 'templateAdd') { return 'templates'; }
    if (this.attemptedAction === 'userAdd') { return 'users'; }
    return 'workspace';
  }

  get freeLimit(): number {
    if (this.attemptedAction === 'harvestAdd') { return this.appStorage.freeHarvests; }
    if (this.attemptedAction === 'templateAdd') { return this.appStorage.freeTemplates; }
    if (this.attemptedAction === 'userAdd') { return this.appStorage.freeUsers; }
    return null;
  }

  successfulUpgrade() {
    //let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigateByUrl('/console/company-settings');
    });
    this.dialogRef.close();
  }
}
